import {TextButton} from '../../index'

const ApproveButton = ({className, onClick}) => {
    return (
        <TextButton className={className} clickHandler={onClick} variant={'contained'}>Approve</TextButton>
    )
}

export default ApproveButton